import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { TablePage } from "~/components/Table";
import { LqsNavigation } from "~/lqs";
import { DigestionTopicFilters } from "./components/DigestionTopicFilters";
import {
  DigestionTopicSearchRequestProvider,
  DigestionTopicTable,
} from "./components/DigestionTopicTable";

export function DigestionTopicsPage() {
  return (
    <TablePage
      title="Search Digestion Topics"
      navigation={<LqsNavigation />}
      RequestProvider={DigestionTopicSearchRequestProvider}
      table={
        <>
          <DataStoreBreadcrumbs />
          <DigestionTopicTable />
        </>
      }
      filters={<DigestionTopicFilters />}
    />
  );
}
